import type { ReactNode } from 'react'

type StickyActionFooterProps = {
  children: ReactNode
  /** Selaraskan dengan lebar shell — delman: max-w-md, kitchen: max-w-5xl */
  maxWidthClass?: string
  /** Naikkan di atas bottom tab bar (Delman/Kitchen shell) */
  aboveTabBar?: boolean
}

/** Preset lebar footer per platform */
export const stickyFooterLayout = {
  delman: { maxWidthClass: 'max-w-md', aboveTabBar: true },
  kitchen: { maxWidthClass: 'max-w-5xl', aboveTabBar: true },
} as const

export function StickyActionFooter({
  children,
  maxWidthClass = stickyFooterLayout.kitchen.maxWidthClass,
  aboveTabBar = false,
}: StickyActionFooterProps) {
  const bottomClass = aboveTabBar ? 'bottom-[4.5rem]' : 'bottom-0'

  return (
    <div className={`fixed ${bottomClass} left-0 right-0 z-20 flex justify-center pointer-events-none`}>
      <div
        className={`w-full ${maxWidthClass} px-4 pointer-events-auto border-t border-outline-variant bg-surface-card pt-4 pb-[max(1rem,env(safe-area-inset-bottom))] shadow-[0_-4px_12px_rgba(0,0,0,0.08)]`}
      >
        <div className="flex flex-col gap-2">{children}</div>
      </div>
    </div>
  )
}
